import clsx from 'clsx';
import { AddOrderIcon } from '../icons/add-order';
import { useForm } from './use-form';
import { Input } from '../shared/input';
import { ProgramDropdown } from '../shared/program-dropdown';
import { DateInput } from '../shared/date-input';

export const NewOrder = (ps: { onClose: () => void; onSubmit: () => void }) => {
  const form = useForm();

  return (
    <div
      className="fixed top-[90px] left-0 w-full backdrop-blur bg-neutral-300/50"
      style={{ height: 'calc(100vh - 90px)' }}
      onClick={ps.onClose}>
      <div
        className="absolute top-10 bottom-10 left-40 right-40 rounded-xl border-4 border-green-500 bg-white flex flex-col p-6"
        onClick={(e) => e.stopPropagation()}>
        <div className="h-20">
          <h1 className="flex items-center gap-4 text-2xl font-bold">
            <AddOrderIcon className="h-6 w-6 fill-black" /> Nuovo Ordine
          </h1>
          <p className="my-2 text-neutral-500 text-sm">
            Compila i campi sottostanti per aggiungere un nuovo ordine.
            <br />
            <span className={clsx(form.hasErrors && 'font-bold text-red-500')}>
              I campi contrassegnati con * sono obbligatori.
            </span>
          </p>
        </div>
        <div
          style={{ height: 'calc(100% - 11rem)' }}
          className="overflow-auto py-6 grid grid-cols-[20%_70%] auto-rows-min gap-6">
          <Input label="ID Ordine" {...form.fields.id} />
          <div />
          <Input label="Codice Articolo" {...form.fields.article_code} />
          <Input
            label="Descrizione Articolo"
            {...form.fields.article_description}
          />
          <Input label="Quantità da produrre" {...form.fields.quantity} />
          <div />
          <ProgramDropdown
            label="Programma Saldatura"
            options={AVAILABLE_PROGRAMS}
            {...form.fields.program}
          />
          <div />
          <div className="col-span-2 flex items-center justify-between">
            <DateInput label="Avvio" {...form.fields.startDate} />
            <DateInput label="Termine" {...form.fields.endDate} />
          </div>
        </div>
        <div className="h-24 flex items-center justify-end gap-2 p-4 font-bold">
          <div
            className="cursor-pointer rounded-lg border-2 border-neutral-400 text-neutral-400 px-8 py-4 transition-transform hover:scale-105"
            onClick={ps.onClose}>
            Annulla
          </div>
          <div
            className={clsx(
              'rounded-lg bg-green-500 text-white p-4 flex items-center gap-4 transition-transform',
              form.valid && !form.isNew
                ? 'cursor-pointer hover:scale-105'
                : 'opacity-50 cursor-not-allowed',
            )}
            onClick={ps.onSubmit}>
            <AddOrderIcon className="h-6 w-6 fill-white" /> Aggiungi Ordine
          </div>
        </div>
      </div>
    </div>
  );
};

const AVAILABLE_PROGRAMS = [
  'R14556-V20',
  'R14556-V21',
  'R14556-V22',
  'R14556-V23',
  'R14556-V24',
];
